import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import useStyles from './styles';
import FileUploader from '../AddAnomaly/FileUploader/FileUploader';
import ApiService from '../../services/ApiService';

export default function CSVFilesImportPopUp(props) {
  const { openCSVFilesImportPopUp } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const [sendClicked, setSendClicked] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [attachment, setAttachment] = React.useState({});

  const [validationResults, setValidationResults] = React.useState([]);

  function resetAll() {
    setValidationResults([]);
    setAttachment({});
  }
  function closeCSVFilesImportPopUp() {
    resetAll();
    props.closeCSVFilesImportPopUp();
  }

  function createFormData() {
    const data = new FormData();
    data.append('file', attachment);
    return data;
  }

  function confirmImport() {
    setSendClicked(true);
    setLoading(true);
    const CSVFiles = createFormData();
    ApiService.validateCSVFiles(CSVFiles)
      .then((response) => {
        setValidationResults(response.data);
        setLoading(false);
      })
      .catch(() => {
        props.closeCSVFilesImportPopUp();
        setLoading(false);
        setAttachment({});
      });
  }

  function getAttachments(file) {
    setAttachment(file[0]);
  }
  function startForcast() {
    setLoading(true);
    const validFiles = validationResults.filter(
      (file) => file.validationErrors == null,
    );
    ApiService.triggerDataModel(validFiles)
      .then(() => {
        props.closeCSVFilesImportPopUp();
        setLoading(false);
        props.openForecastSimulationAlert();
        resetAll();
      })
      .catch(() => {
        props.closeCSVFilesImportPopUp();
        setLoading(false);
        resetAll();
      });
  }
  return (
    <div>
      <Dialog
        open={openCSVFilesImportPopUp}
        onClose={closeCSVFilesImportPopUp}
        maxWidth="md"
        fullWidth
        classes={{ paper: classes.paper }}
      >
        {loading && (
          <Paper
            elevation={0}
            position="absolute"
            zindex="2"
            data-testid="loader"
          >
            <CircularProgress className={classes.loader} />
          </Paper>
        )}
        <Grid container spacing={0}>
          <Grid item xs={1}>
            <PublishIcon className={classes.publishIcon} fontSize="large" />
          </Grid>
          <Grid item xs={11}>
            <DialogTitle className={classes.dialogTitle}>
              <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                  <Typography className={classes.popupTitle}>
                    {t('Simulation parameter importation')}
                  </Typography>
                </Box>
                <Box>
                  <IconButton
                    data-testid="close"
                    onClick={closeCSVFilesImportPopUp}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>
            </DialogTitle>
            {validationResults.length > 0 ? (
              <DialogContent className={classes.dialogContent}>
                <DialogContentText className={classes.dialogText}>
                  {t('files validation results description')}
                </DialogContentText>
                <Typography className={classes.uploadStatusLabel}>
                  {t('Upload status')}
                </Typography>
                <div className={classes.fileUploaderContent}>
                  <ul className={classes.list}>
                    {validationResults.map((validationResult, index) => {
                      const resultId = `result-${index}`;
                      return (
                        <li
                          key={resultId}
                          className={classes.result}
                          data-testid="result"
                        >
                          <Grid container spacing={0}>
                            <Grid item xs={8} container alignItems="flex-end">
                              <Typography className={classes.filename}>
                                {validationResult.fileParameter}
                              </Typography>
                            </Grid>

                            <Grid item xs={4}>
                              <Grid
                                container
                                justify="flex-end"
                                alignItems="flex-end"
                              >
                                {validationResult.validationErrors === null ? (
                                  <div className={classes.flexDiv}>
                                    <Typography
                                      className={classes.succedeedResult}
                                    >
                                      {t('Parameters successfully loaded')}
                                    </Typography>
                                    <CheckCircleOutlineIcon
                                      className={classes.successIcon}
                                    />
                                  </div>
                                ) : (
                                  <div className={classes.flexDiv}>
                                    <Typography className={classes.error}>
                                      {t('Errors')}
                                    </Typography>

                                    <ErrorOutlineIcon
                                      className={classes.errorIcon}
                                    />
                                  </div>
                                )}
                              </Grid>
                            </Grid>
                            {validationResult.validationErrors !== null && (
                              <Grid item xs={2} />
                            )}
                            {validationResult.validationErrors !== null && (
                              <Grid item xs={10}>
                                <Grid
                                  container
                                  justify="flex-end"
                                  alignItems="flex-end"
                                  className={classes.errorGrid}
                                >
                                  <Typography className={classes.error}>
                                    {validationResult.validationErrors}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </DialogContent>
            ) : (
              <DialogContent className={classes.dialogContent}>
                <DialogContentText className={classes.dialogText}>
                  {t('Simulation parameter importation description')}
                </DialogContentText>

                <div className={classes.fileUploaderContent}>
                  <FileUploader
                    isWagonSimulationPage
                    files={[]}
                    sendAttachmentWithFiles={getAttachments}
                    saveClicked={sendClicked}
                  />
                </div>
              </DialogContent>
            )}
            {validationResults.length > 0 ? (
              <DialogActions className={classes.dialogActions}>
                <Button
                  data-testid="forecast"
                  className={classes.forcastButton}
                  onClick={startForcast}
                  variant="contained"
                  autoFocus
                >
                  {t('Start forecast calculation')}
                </Button>
              </DialogActions>
            ) : (
              <DialogActions className={classes.dialogActions}>
                <Button
                  data-testid="cancel"
                  className={classes.cancelButton}
                  onClick={closeCSVFilesImportPopUp}
                  variant="outlined"
                >
                  {t('Cancel')}
                </Button>
                <Button
                  data-testid="validate"
                  className={classes.validateButton}
                  onClick={confirmImport}
                  variant="contained"
                  autoFocus
                >
                  {t('Validate')}
                </Button>
              </DialogActions>
            )}
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
